

module.exports = __webpack_require__.stylable.create(
    "GroupCardMeta1093657831",
    {"classes":{"root":"GroupCardMeta1093657831__root","meta":"GroupCardMeta1093657831__meta","header":"GroupCardMeta1093657831__header","details":"GroupCardMeta1093657831__details","link":"GroupCardMeta1093657831__link","pendingMembers":"GroupCardMeta1093657831__pendingMembers"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "GroupCardMeta1093657831",
    null
);
